import * as React from 'react';
import './index.css';
import { i18nClient } from '@sailor/i18n-mach-pro';

interface IProps {
  anonymousToDelivery: number;
  deliveryCommentScore: number;
  deliveryCommentScoreDesc: string;
  commentLabelList: Array<any>;
  reviewCourierText?: string; // 展示骑手评价文本
}

export default class extends React.PureComponent<IProps> {
  render() {
    const {
      anonymousToDelivery,
      deliveryCommentScore,
      deliveryCommentScoreDesc,
      commentLabelList = [],
      reviewCourierText,
    } = this.props;

    return (
      <view className="rider-card">
        <view className="top-wrap">
          <view className="top-left">
            <image autoRTL className="icon" src="assets://review/rc_rider.png" />
            <text className="title" content={i18nClient.getText('reviews_to_courier')} />
          </view>
          {
            anonymousToDelivery === 1
            && <text className="subtitle" content={i18nClient.getText('reviews_anonymous')} />
          }

        </view>
        <view className="bottom-wrap">
          <view className="bottom-top" style={{ marginBottom: commentLabelList?.length ? 12 : 16 }}>
            <image
              className="icon" src={
                deliveryCommentScore === 5
                  ? 'assets://review/icon_review_like_light.png' : 'assets://review/icon_review_unlike_light.png'
              }
            />
            <text className="bottom-title" content={deliveryCommentScoreDesc} />
          </view>
          {
            commentLabelList?.length && (
              <view className={reviewCourierText ? 'list-wrap-mb2' : 'list-wrap-mb10'}>
                {
                  commentLabelList.map((item) => <text className="item" content={item.name} />)
                }
              </view>
            )
          }
          {/* 展示骑手评价文本 */}
          {reviewCourierText && <text className="comment-text" content={reviewCourierText} />}
        </view>
      </view>
    );
  }
}
